/*
 * Quick View bottom-sheet (custom, House-of-Spoils style)
 * ------------------------------------------------------------------
 * Trigger: a ".qv-trigger" (eye icon) on a product card.
 * Opens a bottom-sheet built from the product's /products/<handle>.js
 * data: a compact header (small thumb + title + artist), the variant
 * options rendered as Frame swatches + a Size grid (other options fall
 * back to toggle buttons), a live price, and Add to Cart.
 *
 * Add-to-cart POSTs to the cart and re-uses the theme's own drawer via
 * theme.addedToCartHandler, so the cart experience matches the rest of
 * the site. Works on mobile + desktop, on the carousel + collection grids.
 */
(function () {
  if (typeof window.jQuery === 'undefined') return;
  var $ = window.jQuery;

  var $sheet, $inner, currentReq, state, arLibsLoaded = false;

  function cache() {
    if ($sheet && $sheet.length) return true;
    $sheet = $('[data-quick-view-sheet]');
    $inner = $sheet.find('[data-qv-inner]');
    return $sheet.length > 0;
  }

  function lockScroll(lock) { $('html').toggleClass('qv-open', lock); }

  function openSheet() {
    if (!cache()) return;
    $sheet.addClass('qv-sheet--active').attr('aria-hidden', 'false');
    lockScroll(true);
  }

  function closeSheet() {
    if (!$sheet || !$sheet.length) return;
    $sheet.removeClass('qv-sheet--active').attr('aria-hidden', 'true');
    lockScroll(false);
    removeAr();
    window.setTimeout(function () {
      if (!$sheet.hasClass('qv-sheet--active')) {
        $inner.html('<div class="qv-sheet__loading"><div class="loading-spinner"></div></div>');
      }
    }, 360);
  }

  // ---- helpers ---------------------------------------------------

  function handleFromUrl(url) {
    var clean = (url || '').split('?')[0].replace(/\/$/, '');
    var m = clean.match(/\/products\/([^\/]+)/);
    return m ? m[1] : null;
  }

  function money(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && window.theme && theme.moneyFormat) {
      try { return Shopify.formatMoney(cents, theme.moneyFormat); } catch (e) {}
    }
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function esc(s) { return (s == null ? '' : String(s)).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  // Resolve the preview image for the current variant (frame), falling back to the
  // product's featured image. Variant images come back as objects ({ src, ... });
  // product.featured_image is a bare URL string. Returns an https, size-suffixed URL
  // so picking a different Frame swaps the preview to that variant's image.
  function qvImage(product, variant, size) {
    var src = (variant && variant.featured_image && variant.featured_image.src) || product.featured_image || '';
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src.replace(/(\.[a-z]+)(\?|$)/i, '_' + (size || 400) + 'x$1$2');
  }

  // Frame option value -> swatch appearance
  function frameSwatch(value) {
    var v = value.toLowerCase();
    if (/no frame|print only|unframed/.test(v)) return { none: true };
    if (/white/.test(v)) return { bg: '#f3f3f3', ring: '#d6d6d6' };
    if (/black/.test(v)) return { bg: '#1c1c1c' };
    if (/dark|espresso|walnut/.test(v)) return { bg: 'linear-gradient(135deg,#5b4029,#3c2a1a)' };
    if (/natural|oak|wood|maple|birch/.test(v)) return { bg: 'linear-gradient(135deg,#d2ad7c,#b07f4e)' };
    if (/gold|brass/.test(v)) return { bg: 'linear-gradient(135deg,#e6c878,#b8923f)' };
    if (/silver|chrome/.test(v)) return { bg: 'linear-gradient(135deg,#e2e2e2,#a9a9a9)' };
    return { bg: '#cfcfcf' };
  }

  // Size option value -> { name, frameDim, printDim }
  // Values look like  "Small | 16.5\"x12.5\" Frame | 12\"x9\" Print"  (the Print part is optional).
  function parseSize(value) {
    var parts = value.split('|').map(function (s) { return s.trim(); });
    var name = parts[0] || value;
    function dimOf(re) {
      var part = parts.filter(function (p) { return re.test(p); })[0];
      if (!part) return '';
      return part.replace(/frame|print(\s*only)?|unframed/ig, '').replace(/\s*x\s*/i, ' × ').replace(/\s+/g, ' ').trim();
    }
    var frameDim = dimOf(/frame/i);
    var printDim = dimOf(/print/i);
    // legacy fallback: a bare second part (no label) is the frame dim
    if (!frameDim && parts[1] && !/print/i.test(parts[1])) {
      frameDim = parts[1].replace(/\s*x\s*/i, ' × ').trim();
    }
    return { name: name, frameDim: frameDim, printDim: printDim };
  }

  function isSizeOption(name) { return /size|dimension/i.test(name); }
  function isFrameOption(name) { return /frame/i.test(name); }
  function isNoFrameValue(value) { return /no frame|print only|unframed/i.test(value || ''); }

  // Is "no frame / print only" currently selected for the Frame option?
  function noFrameSelected(product, selected) {
    return product.options.some(function (opt) {
      var nm = typeof opt === 'string' ? opt : opt.name;
      return isFrameOption(nm) && isNoFrameValue(selected[nm]);
    });
  }

  // ---- variant resolution ---------------------------------------

  function variantFor(product, selected) {
    return product.variants.filter(function (v) {
      return product.options.every(function (opt, i) {
        var nm = typeof opt === 'string' ? opt : opt.name;
        return v.options[i] === selected[nm];
      });
    })[0];
  }

  // Is a given (optionName=value) combination available, holding the
  // other currently-selected options fixed?
  function comboAvailable(product, selected, optName, value) {
    var probe = $.extend({}, selected); probe[optName] = value;
    var v = variantFor(product, probe);
    return v && v.available;
  }

  // ---- rendering -------------------------------------------------

  function render(product) {
    var options = product.options.map(function (o) { return typeof o === 'string' ? { name: o, values: [] } : o; });

    // default selection = first available variant (or first variant)
    var base = product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
    state = { product: product, selected: {} };
    options.forEach(function (opt, i) { state.selected[opt.name] = base.options[i]; });

    var thumb = qvImage(product, base, 400);

    var html = '' +
      '<div class="qv-card">' +
        '<div class="qv-head">' +
          (thumb ? '<div class="qv-head__thumb"><img src="' + esc(thumb) + '" alt="' + esc(product.title) + '" data-qv-thumb loading="lazy"></div>' : '') +
          '<div class="qv-head__meta">' +
            '<div class="qv-head__title"><a href="' + esc(product.url) + '">' + esc(product.title) + '</a></div>' +
            (product.vendor ? '<div class="qv-head__artist">by ' + esc(product.vendor) + '</div>' : '') +
          '</div>' +
        '</div>';

    // Render each option in its own block
    options.forEach(function (opt) {
      var kind = isSizeOption(opt.name) ? 'size' : isFrameOption(opt.name) ? 'frame' : 'toggle';
      html += '<div class="qv-opt qv-opt--' + kind + '" data-qv-opt="' + esc(opt.name) + '">' +
                '<div class="qv-opt__label">' + esc(opt.name) + ' <span class="qv-opt__value" data-qv-optvalue></span></div>';

      if (kind === 'size') {
        html += '<div class="qv-grid">';
        opt.values.forEach(function (val) {
          var s = parseSize(val);
          html += '<button type="button" class="qv-tile" data-qv-set data-opt="' + esc(opt.name) + '" data-val="' + esc(val) + '" data-frame-dim="' + esc(s.frameDim) + '" data-print-dim="' + esc(s.printDim) + '">' +
                    '<span class="qv-tile__name">' + esc(s.name) + '</span>' +
                    '<span class="qv-tile__dim" data-qv-dim>' + esc(s.frameDim) + '</span>' +
                  '</button>';
        });
        html += '</div>';
      } else if (kind === 'frame') {
        html += '<div class="qv-swatches">';
        opt.values.forEach(function (val) {
          var sw = frameSwatch(val);
          var style = sw.none ? '' : 'style="background:' + sw.bg + ';' + (sw.ring ? 'box-shadow: inset 0 0 0 1px ' + sw.ring + ';' : '') + '"';
          html += '<button type="button" class="qv-swatch' + (sw.none ? ' qv-swatch--none' : '') + '" data-qv-set data-opt="' + esc(opt.name) + '" data-val="' + esc(val) + '" aria-label="' + esc(val) + '" title="' + esc(val) + '">' +
                    '<span class="qv-swatch__dot" ' + style + '></span>' +
                  '</button>';
        });
        html += '</div>';
      } else {
        html += '<div class="qv-toggle">';
        opt.values.forEach(function (val) {
          html += '<button type="button" class="qv-toggle__btn" data-qv-set data-opt="' + esc(opt.name) + '" data-val="' + esc(val) + '">' + esc(val) + '</button>';
        });
        html += '</div>';
      }
      html += '</div>';
    });

    html += '' +
        '<div class="qv-foot">' +
          '<div class="qv-price" data-qv-price></div>' +
          '<button type="button" class="qv-add" data-qv-add>' + (window.theme && theme.strings && theme.strings.products_product_add_to_cart ? esc(theme.strings.products_product_add_to_cart) : 'Add to Cart') + '</button>' +
        '</div>' +
        '<div class="qv-ar" data-qv-ar hidden></div>' +
      '</div>';

    $inner.html(html);
    syncUI();
    loadAr(product);
  }

  // Reflect current selection into the UI (active states, availability, price)
  function syncUI() {
    var product = state.product, selected = state.selected;

    $inner.find('[data-qv-opt]').each(function () {
      var optName = $(this).attr('data-qv-opt');
      $(this).find('[data-qv-optvalue]').text(prettyValue(optName, selected[optName]));
      $(this).find('[data-qv-set]').each(function () {
        var val = $(this).attr('data-val');
        var on = val === selected[optName];
        var avail = comboAvailable(product, selected, optName, val);
        $(this).toggleClass('is-selected', on)
               .toggleClass('is-unavailable', !avail)
               .attr('aria-pressed', on ? 'true' : 'false');
      });
    });

    // Swap framed ↔ print dimensions on the size tiles when "no frame / print only" is selected.
    var noFrame = noFrameSelected(product, selected);
    $inner.find('.qv-opt--size .qv-tile').each(function () {
      var fd = $(this).attr('data-frame-dim') || '';
      var pd = $(this).attr('data-print-dim') || '';
      $(this).find('[data-qv-dim]').text(noFrame ? (pd || fd) : fd);
    });

    var v = variantFor(product, selected);
    var imgSrc = qvImage(product, v, 400);
    if (imgSrc) $inner.find('[data-qv-thumb]').attr('src', imgSrc);
    $inner.find('[data-qv-price]').text(v ? money(v.price) : '');
    var $add = $inner.find('[data-qv-add]');
    if (!v || !v.available) {
      $add.attr('disabled', 'disabled').text(window.theme && theme.strings && theme.strings.products_product_sold_out ? theme.strings.products_product_sold_out : 'Sold Out');
    } else {
      $add.removeAttr('disabled').text(window.theme && theme.strings && theme.strings.products_product_add_to_cart ? theme.strings.products_product_add_to_cart : 'Add to Cart');
    }
    state.variant = v;
    arSyncVariant();
  }

  function prettyValue(optName, value) {
    if (isSizeOption(optName)) return parseSize(value).name;
    return value;
  }

  // ---- cart ------------------------------------------------------

  function addToCart() {
    var v = state && state.variant;
    if (!v || !v.available) return;
    var $add = $inner.find('[data-qv-add]').attr('disabled', 'disabled').text(window.theme && theme.strings && theme.strings.products_product_adding_to_cart ? theme.strings.products_product_adding_to_cart : 'Adding…');
    var addUrl = (window.theme && theme.routes && theme.routes.cart_add_url) ? theme.routes.cart_add_url : '/cart/add.js';
    var body = 'id=' + encodeURIComponent(v.id) + '&quantity=1&sections=cart-drawer';
    $.post(addUrl, body, function (response) {
      // Re-use the theme's drawer if we got the section back, else just refresh.
      if (window.theme && typeof theme.addedToCartHandler === 'function' && response && response.sections && response.sections['cart-drawer']) {
        try { theme.addedToCartHandler.call($add, response); } catch (e) {}
      } else {
        document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles: true }));
      }
      closeSheet();
    }, 'json').fail(function () {
      $add.removeAttr('disabled').text('Try again');
    });
  }

  // ---- View in Your Room (WAVAR / Cart Magician AR app) ----------
  // The "View in your room" AR launcher is a Shopify app block that only
  // renders on the product page. For Quick View we fetch the PDP, lift its
  // WAVAR block (and its QR modal) into the sheet, load the app's libraries
  // once, then (re)run its inline init each open so the device-correct button
  // works. Products without the block simply show no AR button.

  function removeAr() {
    // The block lives in [data-qv-ar] (wiped when $inner re-renders). Its QR
    // modal + inline init scripts go on <body>, and the app's own init appends
    // extra modal copies — none tagged. The QV host page (collection/home) has
    // no native WAVAR, so every WavPopupModal here is one we caused: clear all.
    $('[id^="WavPopupModal-"], [data-qv-ar-modal], [data-qv-ar-script]').remove();
  }

  // Best-effort: point the AR model at the currently-selected variant.
  function arSyncVariant() {
    var v = state && state.variant;
    if (v && typeof window.wavUpdateVariantArAsset === 'function') {
      try { window.wavUpdateVariantArAsset(v.id); } catch (e) {}
    }
  }

  function loadAr(product) {
    if (!cache()) return;
    var slot = $inner.find('[data-qv-ar]')[0];
    if (!slot || !product || !product.url) return;
    $.get(product.url).done(function (html) {
      var root, modal, doc;
      try { doc = new DOMParser().parseFromString(html, 'text/html'); } catch (e) { return; }
      root = doc.querySelector('.wavar-subscription-gate-root, [id^="wavar-launch-ar-root"]');
      if (!root) return; // no AR for this product — leave the slot hidden
      var opener = root.querySelector('[data-wavar-modal]');
      var modalSel = opener && opener.getAttribute('data-wavar-modal');
      modal = modalSel && doc.querySelector(modalSel);

      var links = [].slice.call(root.querySelectorAll('link[rel="stylesheet"]'));
      var extScripts = [].slice.call(root.querySelectorAll('script[src]'));
      var inlineScripts = [].slice.call(root.querySelectorAll('script:not([src])'));

      // Inject the markup only (we run scripts/links ourselves, controlled).
      var rootClone = document.importNode(root, true);
      [].slice.call(rootClone.querySelectorAll('script, link[rel="stylesheet"]')).forEach(function (n) { n.remove(); });
      slot.innerHTML = '';
      slot.appendChild(rootClone);
      slot.removeAttribute('hidden');
      if (modal) {
        var m = document.importNode(modal, true);
        m.setAttribute('data-qv-ar-modal', '1');
        document.body.appendChild(m);
      }

      function runInline() {
        inlineScripts.forEach(function (old) {
          var s = document.createElement('script');
          s.setAttribute('data-qv-ar-script', '1');
          s.textContent = old.textContent;
          document.body.appendChild(s);
        });
        ['initaliseWavVisibility', 'initialiseWavAssets', 'initaliseWavEvents', 'cmInitAllWavarModals'].forEach(function (fn) {
          try { if (typeof window[fn] === 'function') window[fn](); } catch (e) {}
        });
        arSyncVariant();
      }

      if (arLibsLoaded) { runInline(); return; }
      // First use only: load the app's CSS + JS libraries once.
      links.forEach(function (l) {
        var href = l.getAttribute('href');
        if (href && !document.querySelector('link[href="' + href + '"]')) document.head.appendChild(document.importNode(l, true));
      });
      var i = 0;
      (function next() {
        if (i >= extScripts.length) { arLibsLoaded = true; runInline(); return; }
        var src = extScripts[i++].getAttribute('src');
        if (!src || document.querySelector('script[src="' + src + '"]')) return next();
        var s = document.createElement('script');
        s.src = src; s.onload = next; s.onerror = next;
        document.head.appendChild(s);
      })();
    });
  }

  // ---- load ------------------------------------------------------

  function loadProduct(url) {
    if (!cache()) return;
    var handle = handleFromUrl(url);
    if (!handle) { window.location.href = url; return; }
    removeAr();
    openSheet();
    $inner.html('<div class="qv-sheet__loading"><div class="loading-spinner"></div></div>');
    if (currentReq) currentReq.abort();
    currentReq = $.getJSON('/products/' + handle + '.js', function (product) {
      render(product);
    }).fail(function () {
      window.location.href = url;
    }).always(function () { currentReq = false; });
  }

  // ---- events ----------------------------------------------------

  $(document).on('click', '[data-quick-view]', function (e) {
    e.preventDefault(); e.stopPropagation();
    loadProduct($(this).attr('data-product-url') || $(this).attr('href'));
  });

  $(document).on('click', '[data-qv-set]', function () {
    if ($(this).hasClass('is-unavailable')) { /* allow re-select to show sold out */ }
    var opt = $(this).attr('data-opt'), val = $(this).attr('data-val');
    if (state && state.selected[opt] !== val) { state.selected[opt] = val; syncUI(); }
  });

  $(document).on('click', '[data-qv-add]', function (e) { e.preventDefault(); addToCart(); });
  $(document).on('click', '[data-qv-close]', function (e) { e.preventDefault(); closeSheet(); });
  $(document).on('keydown', function (e) { if (e.key === 'Escape' || e.keyCode === 27) closeSheet(); });
})();
